export default __webpack_public_path__ + "static/media/check.ae6cf2cb.png";